import React from "react";
import { Box } from "@nubeteck/components";
import { Skeleton } from "antd";
import { LargeHeadingStyled } from "../texts/texts.styled";
import {
  DashboardImage,
  WelcomeCardStyled,
  WelcomeDescText,
} from "../../../pages/dashboard/dashboard.styled";
import { DashboardSVG } from "../../../assets";
import { getHomeAutoservicioPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { useState, useEffect } from "react";
import { StrapiError } from "../../../pages/StrapiError";

const WelcomeCard = ({ welcomeText }: { welcomeText: string }) => {
  const { locale } = useLocale();
  const [homeAutoservicioPage, setHomeAutoservicioPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setHomeAutoservicioPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getHomeAutoservicioPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setHomeAutoservicioPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setHomeAutoservicioPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setHomeAutoservicioPage(null);
      }}
    />;
  }

  return (
    <WelcomeCardStyled>
      <Box>
        <LargeHeadingStyled>
          {isLoadingContent ? (
            <Skeleton.Input active size="large" style={{ width: 400 }} />
          ) : (
            homeAutoservicioPage?.title ?? "Bienvenido(a) al sistema de Autoservicio"
          )}
        </LargeHeadingStyled>
        <WelcomeDescText>{welcomeText}</WelcomeDescText>
      </Box>
      <DashboardImage preview={false} src={DashboardSVG} />
    </WelcomeCardStyled>
  );
};

export default WelcomeCard;
